import React from 'react';
import { I18n } from 'react-redux-i18n-lite';

const DeletedMessage = () => {
  return (
    <div className="discussion-posts-wrapper">
      <div className="removed-message">{I18n.t('discussions.common.messageRemoved')}</div>
    </div>
  );
};

export default DeletedMessage;
